export default __webpack_public_path__ + "static/media/usb.8dc7561f.svg";